import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import * as React from 'react';
import { AppsSection } from '../apps-section';
import { BusinessHeader } from '../apps-section/apps-section-headers/business.apps-section-header';
import { RegularHeader } from '../apps-section/apps-section-headers/regular.apps-section-header';
import { CompleteSetupHeader } from '../apps-section/apps-section-headers/complete-setup.apps-section-header';
import { withTranslation } from '../../component-decorators/with-translation';
import { fetchBundleApps, fetchInstalledApps, fetchSiteData, getAllEmbeddedScriptAppsStatus, getPermittedActions, newDeleteApp, setEmbeddedScriptAppActive, } from '../../api';
import { ModalNames, Modals } from '../modals/modals';
import { EmptyState } from '../empty-state';
import s from './manage-installed-apps-page.scss';
import { sendAddAppBi, sendOpenManageAppsBi } from '../../bi/biEvents';
import ChevronRight from 'wix-ui-icons-common/ChevronRight';
import { Page, Loader, Button, Box, Heading, TextButton, Divider, WixStyleReactProvider, } from 'wix-style-react';
import { RecommendedApps } from '../empty-state/recommended-apps';
import { withExperiments } from '../../component-decorators/with-experiments';
import { PermissionsCtx } from '../permissions-context/permissions-ctx';
import { NotificationNames } from '../notifications/notifications';
import { MarketingIntegrationsToast } from '../modals/marketing-integrations-toast/marketing-integrations-toast';
import { appHasEditor, isPendingApp, isBusinessApp, isRegularApp, enableDeleteMLApp, } from '../../utils/appUtils';
import { enrichBundleApps, getAppsRequiredPremium, getCompleteSetupApps, getDeepLink, } from '../../utils/utils';
import { HeaderHolidaySaleExport } from '@wix/app-market-collection-widget';
export var Origin;
(function (Origin) {
    Origin["BIZMGR"] = "bizmgr";
    Origin["EDITOR"] = "editor";
})(Origin || (Origin = {}));
export var embeddedScriptAppStatus;
(function (embeddedScriptAppStatus) {
    embeddedScriptAppStatus["ENABLED"] = "enabled";
    embeddedScriptAppStatus["DISABLED"] = "disabled";
    embeddedScriptAppStatus["MISSING"] = "missing";
    embeddedScriptAppStatus["NO_STATUS"] = "noStatus";
})(embeddedScriptAppStatus || (embeddedScriptAppStatus = {}));
export var EditorType;
(function (EditorType) {
    EditorType["EDITOR"] = "EDITOR";
    EditorType["EDITORX"] = "EDITORX";
    EditorType["ADI"] = "ADI";
})(EditorType || (EditorType = {}));
var ManageInstalledAppsPage = /** @class */ (function (_super) {
    __extends(ManageInstalledAppsPage, _super);
    function ManageInstalledAppsPage(props) {
        var _this = _super.call(this, props) || this;
        _this.closeModal = function () { return __awaiter(_this, void 0, void 0, function () {
            var embeddedScriptAppsStatus;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.state.modalProps.openModalName === ModalNames.APP_SETTINGS) {
                    embeddedScriptAppsStatus = this.fetchEmbeddedScriptAppsStatus(this.state.installedApps).then(function (data) { return _this.setState({ embeddedScriptAppsStatus: data }); });
                }
                this.setState({
                    openModal: ModalNames.NONE,
                    modalProps: { openModalName: ModalNames.NONE },
                });
                return [2 /*return*/];
            });
        }); };
        _this.openModal = function (modalName, modalProps) {
            var authorizationHeader = _this.props.getAppInstance
                ? _this.props.getAppInstance(_this.state.msAppId)
                : '';
            var fullModalProps = __assign({ editorType: _this.props.editorType, openModalName: modalName, closeModal: _this.closeModal, baseUrl: _this.props.baseUrl, authorizationHeader: authorizationHeader, origin: _this.props.origin, editorUrl: _this.props.editorUrl, manageAppsStaticsUrl: _this.props.manageAppsStaticsUrl, deleteApp: _this.deleteAppAndUpdatePage, locale: _this.props.locale, msId: _this.props.metasiteId, showUserActionNotification: _this.props.showUserActionNotification, openDeleteModalAppInEditor: _this.props.openDeleteModalAppInEditor }, modalProps);
            _this.setState({
                openModal: modalProps.openModalName,
                modalProps: fullModalProps,
            });
        };
        _this.goToWebSolutionPage = function (e, slug) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                e.stopPropagation();
                window.location.replace(window.location.origin + "/dashboard/" + this.props.metasiteId + "/app-market/web-solution/" + slug);
                return [2 /*return*/];
            });
        }); };
        _this.deleteAppByType = function (baseUrl, msid, appToDelete, authorizationHeader, editorType) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.props.experiments.enabled('specs.marketplace.delete-all-apps') ||
                    enableDeleteMLApp(appToDelete, this.props.experiments) ||
                    (appHasEditor(appToDelete) &&
                        !isPendingApp(appToDelete) &&
                        editorType === EditorType.EDITOR)) {
                    return [2 /*return*/, this.props.unInstallApp(appToDelete.webSolutionBase.id)];
                }
                return [2 /*return*/, newDeleteApp(baseUrl, authorizationHeader, appToDelete.webSolutionBase.id)];
            });
        }); };
        _this.deleteAppAndUpdatePage = function (appToDelete, showNotification) {
            var _a = _this.props, baseUrl = _a.baseUrl, getAppInstance = _a.getAppInstance, experiments = _a.experiments, locale = _a.locale, editorType = _a.editorType, hideBusinessSolutions = _a.hideBusinessSolutions, geo = _a.geo;
            var authorizationHeader = getAppInstance
                ? getAppInstance(_this.state.msAppId)
                : '';
            var shouldSendGeo = experiments.enabled('specs.marketplace.bundle-on-geo');
            var geoString = shouldSendGeo ? geo : '';
            _this.deleteAppByType(baseUrl, _this.props.metasiteId, appToDelete, authorizationHeader, editorType)
                .then(function () { return __awaiter(_this, void 0, void 0, function () {
                var installedApps, bundleApps, enrichedBundleApps, appName;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, fetchInstalledApps(baseUrl, authorizationHeader, locale, hideBusinessSolutions)];
                        case 1:
                            installedApps = _a.sent();
                            return [4 /*yield*/, fetchBundleApps(baseUrl, authorizationHeader, locale, geoString)];
                        case 2:
                            bundleApps = _a.sent();
                            enrichedBundleApps = enrichBundleApps(bundleApps, installedApps);
                            if (showNotification) {
                                appName = appToDelete.webSolutionBase.name;
                                this.props.showUserActionNotification({
                                    message: this.props
                                        .t('manage-apps.delete-modal.deletion-notification', { appName: appName })
                                        .replace('&amp;', '&'),
                                    biName: 'delete-app',
                                    type: 'SUCCESS',
                                });
                            }
                            this.setState({
                                installedApps: installedApps,
                                bundleApps: enrichedBundleApps,
                            });
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (e) {
                if (showNotification) {
                    var appName = appToDelete.webSolutionBase.name;
                    _this.props.showUserActionNotification({
                        message: _this.props
                            .t('manage-apps.delete-modal.deletion-error', { appName: appName })
                            .replace('&amp;', '&'),
                        biName: 'delete-app',
                        type: 'ERROR',
                        action: {
                            text: _this.props.t('manage-apps.delete-modal.deletion-error-cta'),
                            uiType: 'link',
                            navigationTarget: {
                                url: _this.props.t('manage-apps.delete-modal.deletion-error-link'),
                            },
                        },
                        link: {
                            caption: _this.props.t('manage-apps.delete-modal.deletion-error-cta'),
                            onNotificationLinkClick: function () {
                                if (window) {
                                    window.open(_this.props.t('manage-apps.delete-modal.deletion-error-link'));
                                }
                            },
                        },
                    });
                }
            });
        };
        _this.updateEmbeddedScriptAppsStatus = function (appDefId, newStatus, appInstanceId, embeddedScriptAppsStatus) {
            var isDisabled = newStatus === embeddedScriptAppStatus.DISABLED;
            _this.handleEmbeddedScriptToggle(appDefId, isDisabled, appInstanceId, _this.state.embeddedScriptAppsStatus)
                .then(function (res) {
                var status = __assign({}, _this.state.embeddedScriptAppsStatus);
                // @ts-ignore
                var appStatus = res.status;
                // @ts-ignore
                var newParameters = res.parameters;
                var newStatusEnum = appStatus === 'disabled'
                    ? embeddedScriptAppStatus.DISABLED
                    : embeddedScriptAppStatus.ENABLED;
                status[appDefId] = {
                    status: newStatusEnum,
                    parameters: newParameters,
                };
                _this.setState({ embeddedScriptAppsStatus: status });
            })
                .catch(function (e) { return console.log(e); });
        };
        _this.deleteAppFromBundle = function (appId) {
            var apps = _this.state.bundleApps
                ? _this.state.bundleApps.filter(function (app) { return app.webSolutionBase.id !== appId; })
                : [];
            _this.setState({ bundleApps: apps });
        };
        _this.refetchApps = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, installedApps, embeddedScriptAppsStatus, bundleApps;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setState({
                            isFetching: true,
                        });
                        return [4 /*yield*/, this.fetchApps()];
                    case 1:
                        _a = _b.sent(), installedApps = _a.installedApps, embeddedScriptAppsStatus = _a.embeddedScriptAppsStatus, bundleApps = _a.bundleApps;
                        this.setState({
                            isFetching: false,
                            installedApps: installedApps,
                            embeddedScriptAppsStatus: embeddedScriptAppsStatus,
                            bundleApps: bundleApps,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            installedApps: [],
            bundleApps: [],
            isFetching: true,
            embeddedScriptAppsStatus: {},
            msAppId: '22bef345-3c5b-4c18-b782-74d4085112ff',
            openModal: ModalNames.NONE,
            openNotificationName: NotificationNames.NONE,
        };
        return _this;
    }
    ManageInstalledAppsPage.prototype.convertEmbeddedScriptAppsStatus = function (apps) {
        var initialValue = {};
        return apps === null || apps === void 0 ? void 0 : apps.reduce(function (obj, app) {
            var _a;
            return __assign(__assign({}, obj), (_a = {}, _a[app.webSolutionBase.id] = {
                status: app.status,
                parameters: app.parameters,
            }, _a));
        }, initialValue);
    };
    ManageInstalledAppsPage.prototype.fetchEmbeddedScriptAppsStatus = function (apps) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, baseUrl, getAppInstance, signedInstance, statusAsArray;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, baseUrl = _a.baseUrl, getAppInstance = _a.getAppInstance;
                        signedInstance = getAppInstance(this.state.msAppId);
                        return [4 /*yield*/, getAllEmbeddedScriptAppsStatus(signedInstance, baseUrl, apps)];
                    case 1:
                        statusAsArray = _b.sent();
                        return [2 /*return*/, this.convertEmbeddedScriptAppsStatus(statusAsArray)];
                }
            });
        });
    };
    ManageInstalledAppsPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, baseUrl, metasiteId, hideBusinessSolutions, getAppInstance, locale, _b, installedApps, embeddedScriptAppsStatus, bundleApps, allApps, signedInstance, deepLinkState, permissions, siteData, siteIsPremium;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, baseUrl = _a.baseUrl, metasiteId = _a.metasiteId, hideBusinessSolutions = _a.hideBusinessSolutions, getAppInstance = _a.getAppInstance, locale = _a.locale;
                        return [4 /*yield*/, this.fetchApps()];
                    case 1:
                        _b = _c.sent(), installedApps = _b.installedApps, embeddedScriptAppsStatus = _b.embeddedScriptAppsStatus, bundleApps = _b.bundleApps;
                        allApps = [];
                        signedInstance = getAppInstance(this.state.msAppId);
                        if (!(hideBusinessSolutions && this.props.deepLinkData)) return [3 /*break*/, 3];
                        return [4 /*yield*/, fetchInstalledApps(baseUrl, signedInstance, locale, false)];
                    case 2:
                        allApps = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        allApps = installedApps;
                        _c.label = 4;
                    case 4:
                        deepLinkState = getDeepLink(this.props.deepLinkData, allApps);
                        return [4 /*yield*/, getPermittedActions(baseUrl, this.props.metasiteId)];
                    case 5:
                        permissions = _c.sent();
                        return [4 /*yield*/, fetchSiteData(metasiteId, baseUrl)];
                    case 6:
                        siteData = _c.sent();
                        siteIsPremium = siteData && siteData.siteIsPremium;
                        this.setState({
                            isFetching: false,
                            installedApps: installedApps,
                            embeddedScriptAppsStatus: embeddedScriptAppsStatus,
                            permissions: permissions,
                            siteIsPremium: siteIsPremium,
                            bundleApps: bundleApps,
                        });
                        sendOpenManageAppsBi(this.props.origin, this.props.metasiteId, this.props.editorType);
                        if (deepLinkState && deepLinkState.modalProps) {
                            this.openModal(deepLinkState.openModal, deepLinkState.modalProps);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ManageInstalledAppsPage.prototype.handleEmbeddedScriptToggle = function (appDefId, newStatus, appInstanceId, embeddedScriptAppsStatus) {
        return __awaiter(this, void 0, void 0, function () {
            var msSignedInstance;
            return __generator(this, function (_a) {
                msSignedInstance = this.props.getAppInstance(this.state.msAppId);
                if (msSignedInstance && appInstanceId) {
                    return [2 /*return*/, setEmbeddedScriptAppActive(newStatus, msSignedInstance, appInstanceId, this.props.baseUrl, embeddedScriptAppsStatus[appDefId])
                            .then(function (result) {
                            return {
                                status: result.data.properties.disabled
                                    ? embeddedScriptAppStatus.DISABLED
                                    : embeddedScriptAppStatus.ENABLED,
                                parameters: result.data.properties.parameters,
                            };
                        })
                            .catch(function (e) { return false; })];
                }
                return [2 /*return*/];
            });
        });
    };
    ManageInstalledAppsPage.prototype.fetchApps = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, baseUrl, getAppInstance, locale, hideBusinessSolutions, geo, experiments, signedInstance, shouldSendGeo, geoString, installedApps, bundleApps, enrichedBundleApps, embeddedScriptAppsStatus;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, baseUrl = _a.baseUrl, getAppInstance = _a.getAppInstance, locale = _a.locale, hideBusinessSolutions = _a.hideBusinessSolutions, geo = _a.geo, experiments = _a.experiments;
                        signedInstance = getAppInstance(this.state.msAppId);
                        shouldSendGeo = experiments.enabled('specs.marketplace.bundle-on-geo');
                        geoString = shouldSendGeo ? geo : '';
                        return [4 /*yield*/, fetchInstalledApps(baseUrl, signedInstance, locale, hideBusinessSolutions)];
                    case 1:
                        installedApps = _b.sent();
                        return [4 /*yield*/, fetchBundleApps(baseUrl, signedInstance, locale, geoString)];
                    case 2:
                        bundleApps = _b.sent();
                        enrichedBundleApps = enrichBundleApps(bundleApps, installedApps);
                        return [4 /*yield*/, this.fetchEmbeddedScriptAppsStatus(installedApps)];
                    case 3:
                        embeddedScriptAppsStatus = _b.sent();
                        return [2 /*return*/, {
                                installedApps: installedApps,
                                embeddedScriptAppsStatus: embeddedScriptAppsStatus,
                                bundleApps: enrichedBundleApps,
                            }];
                }
            });
        });
    };
    ManageInstalledAppsPage.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var _c = this.props, t = _c.t, goToHomePage = _c.goToHomePage, mainButtonAction = _c.mainButtonAction, addAppAgain = _c.addAppAgain, getAppInstance = _c.getAppInstance, origin = _c.origin, metasiteId = _c.metasiteId, experiments = _c.experiments, editorType = _c.editorType, referralInfo = _c.referralInfo;
        var hasAppsInstalled, completeSetupApps, regularApps, businessApps, appsRequiredPremium, hasBundleApps, authorizationHeader;
        if (!this.state.isFetching) {
            hasAppsInstalled = this.state.installedApps.length;
            hasBundleApps = (_a = this.state.bundleApps) === null || _a === void 0 ? void 0 : _a.length;
            appsRequiredPremium = getAppsRequiredPremium(this.state.siteIsPremium, this.state.installedApps);
            completeSetupApps = getCompleteSetupApps(this.state.installedApps, this.state.bundleApps, this.state.siteIsPremium, experiments);
            regularApps = (_b = this.state.installedApps) === null || _b === void 0 ? void 0 : _b.filter(function (app) {
                return isRegularApp(app) &&
                    completeSetupApps.findIndex(function (completeSetupApp) {
                        return completeSetupApp.webSolutionBase.id === app.webSolutionBase.id;
                    }) === -1;
            });
            businessApps = this.state.installedApps.filter(isBusinessApp);
            authorizationHeader = getAppInstance
                ? getAppInstance(this.state.msAppId)
                : '';
        }
        var reducedSpacing = experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.reducedSpacing');
        var showHolidaySale = experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.blackFridaySale');
        // @ts-ignore
        return (React.createElement(WixStyleReactProvider, { features: { reducedSpacingAndImprovedLayout: reducedSpacing }, as: 'span' },
            React.createElement(React.Fragment, null,
                React.createElement(Modals, __assign({}, this.state.modalProps)),
                referralInfo === 'marketing-integrations' && (React.createElement(MarketingIntegrationsToast, { navigateToMarketingIntegration: this.props.navigateToMarketingIntegration })),
                this.state.isFetching && (React.createElement("div", { className: s.loaderWrapper },
                    React.createElement(Loader, { size: "medium" }))),
                !this.state.isFetching &&
                    (hasAppsInstalled || hasBundleApps ? (React.createElement(Page, null,
                        React.createElement(Page.Header, { dataHook: 'manage-apps-page-header', title: t('manage-apps.page.title'), subtitle: t('manage-apps.page.subtitle'), actionsBar: React.createElement(Button, { priority: experiments &&
                                    experiments.enabled('specs.marketplace.manage-apps.cta-color-change')
                                    ? 'primary'
                                    : 'secondary', onClick: function () {
                                    sendAddAppBi(_this.props.origin, _this.props.metasiteId, editorType);
                                    goToHomePage();
                                }, dataHook: 'manage-apps-go-to-app-market' }, t('manage-apps.get-more-apps')) }),
                        React.createElement(Page.Content, null,
                            React.createElement(React.Fragment, null,
                                React.createElement(HeaderHolidaySaleExport, { locale: this.props.locale, skin: 'manage-apps', origin: origin, onClick: this.props.goToHolidaySaleCategoryPage, msId: metasiteId, referral: 'manage-apps' }),
                                showHolidaySale && React.createElement(Box, { marginBottom: '24px' })),
                            React.createElement(PermissionsCtx.Provider, { value: this.state.permissions },
                                React.createElement(React.Fragment, null,
                                    React.createElement(AppsSection, { apps: completeSetupApps, origin: this.props.origin, msid: this.props.metasiteId, mainButtonAction: function (app) {
                                            mainButtonAction(app, _this.refetchApps);
                                        }, getAppInstance: getAppInstance, openModal: this.openModal, baseUrl: this.props.baseUrl, deleteApp: this.deleteAppAndUpdatePage, isBusinessApp: false, editorType: editorType, gotoWebSolutionPage: this.props.gotoWebSolutionPage, updateEmbeddedScriptAppsStatus: this.updateEmbeddedScriptAppsStatus, embeddedScriptAppsStatus: this.state.embeddedScriptAppsStatus, siteIsPremium: this.state.siteIsPremium, isActionRequiredSection: true, openApp: this.props.openApp, deleteAppFromBundle: this.deleteAppFromBundle, siteIsBusinessFirstSite: this.props.siteIsBusinessFirstSite, dataHook: "pendingSection" },
                                        React.createElement(CompleteSetupHeader, { badgeCounter: completeSetupApps.length })),
                                    React.createElement(AppsSection, { apps: regularApps, origin: this.props.origin, msid: this.props.metasiteId, mainButtonAction: function (app) {
                                            return mainButtonAction(app, _this.refetchApps);
                                        }, addAppAgain: addAppAgain, getAppInstance: getAppInstance, updateEmbeddedScriptAppsStatus: this.updateEmbeddedScriptAppsStatus, embeddedScriptAppsStatus: this.state.embeddedScriptAppsStatus, openModal: this.openModal, baseUrl: this.props.baseUrl, deleteApp: this.deleteAppAndUpdatePage, isBusinessApp: false, editorType: editorType, gotoWebSolutionPage: this.props.gotoWebSolutionPage, siteIsPremium: this.state.siteIsPremium, dataHook: "installedSection", showHolidaySale: showHolidaySale, locale: this.props.locale },
                                        React.createElement(RegularHeader, null)),
                                    React.createElement(AppsSection, { apps: businessApps, origin: this.props.origin, msid: this.props.metasiteId, mainButtonAction: function (app) {
                                            return mainButtonAction(app, _this.refetchApps);
                                        }, addAppAgain: addAppAgain, getAppInstance: getAppInstance, openModal: this.openModal, baseUrl: this.props.baseUrl, deleteApp: this.deleteAppAndUpdatePage, isBusinessApp: true, editorType: editorType, gotoWebSolutionPage: this.props.gotoWebSolutionPage, siteIsPremium: this.state.siteIsPremium, dataHook: "businessSolutionsSection" },
                                        React.createElement(BusinessHeader, null)),
                                    React.createElement(Box, { align: 'space-between', verticalAlign: 'middle', marginTop: '48px', marginBottom: '18px' },
                                        React.createElement(Heading, { dataHook: 'recommended-apps-title', appearance: 'H3' }, t('manage-apps.recommended-for-you')),
                                        React.createElement(TextButton, { suffixIcon: React.createElement(ChevronRight, null), onClick: function () {
                                                sendAddAppBi(_this.props.origin, _this.props.metasiteId, editorType);
                                                goToHomePage();
                                            } }, t('manage-apps.see-all-apps'))),
                                    React.createElement("div", { style: { marginBottom: '12px' } },
                                        React.createElement(Divider, null)),
                                    React.createElement(RecommendedApps, { baseUrl: this.props.baseUrl, authorizationHeader: authorizationHeader, locale: this.props.locale, origin: this.props.origin, gotoWebSolutionPage: this.props.gotoWebSolutionPage, editorType: editorType, msid: this.props.metasiteId })))))) : (React.createElement(EmptyState, { baseUrl: this.props.baseUrl, msid: this.props.metasiteId, locale: this.props.locale, gotoWebSolutionPage: this.props.gotoWebSolutionPage, goToHomePage: this.props.goToHomePage, origin: this.props.origin, editorType: editorType, authorizationHeader: authorizationHeader }))))));
    };
    ManageInstalledAppsPage = __decorate([
        withTranslation,
        withExperiments
    ], ManageInstalledAppsPage);
    return ManageInstalledAppsPage;
}(React.Component));
export { ManageInstalledAppsPage };
//# sourceMappingURL=manage-installed-apps-page.js.map